/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateInsuredPayloadDto
 */
export interface UpdateInsuredPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateInsuredPayloadDto
     */
    status?: UpdateInsuredPayloadDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateInsuredPayloadDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInsuredPayloadDto
     */
    longName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInsuredPayloadDto
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInsuredPayloadDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInsuredPayloadDto
     */
    postcode?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInsuredPayloadDto
     */
    country: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateInsuredPayloadDto
     */
    sanctionsCompleted?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof UpdateInsuredPayloadDto
     */
    sanctionsCompletedDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateInsuredPayloadDto
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInsuredPayloadDto
     */
    state?: string;
}


/**
 * @export
 */
export const UpdateInsuredPayloadDtoStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive'
} as const;
export type UpdateInsuredPayloadDtoStatusEnum = typeof UpdateInsuredPayloadDtoStatusEnum[keyof typeof UpdateInsuredPayloadDtoStatusEnum];


/**
 * Check if a given object implements the UpdateInsuredPayloadDto interface.
 */
export function instanceOfUpdateInsuredPayloadDto(value: object): value is UpdateInsuredPayloadDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function UpdateInsuredPayloadDtoFromJSON(json: any): UpdateInsuredPayloadDto {
    return UpdateInsuredPayloadDtoFromJSONTyped(json, false);
}

export function UpdateInsuredPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateInsuredPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'name': json['name'],
        'longName': json['longName'] == null ? undefined : json['longName'],
        'address': json['address'] == null ? undefined : json['address'],
        'city': json['city'] == null ? undefined : json['city'],
        'postcode': json['postcode'] == null ? undefined : json['postcode'],
        'country': json['country'],
        'sanctionsCompleted': json['sanctionsCompleted'] == null ? undefined : json['sanctionsCompleted'],
        'sanctionsCompletedDate': json['sanctionsCompletedDate'] == null ? undefined : (new Date(json['sanctionsCompletedDate'])),
        'comment': json['comment'] == null ? undefined : json['comment'],
        'state': json['state'] == null ? undefined : json['state'],
    };
}

export function UpdateInsuredPayloadDtoToJSON(json: any): UpdateInsuredPayloadDto {
    return UpdateInsuredPayloadDtoToJSONTyped(json, false);
}

export function UpdateInsuredPayloadDtoToJSONTyped(value?: UpdateInsuredPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'name': value['name'],
        'longName': value['longName'],
        'address': value['address'],
        'city': value['city'],
        'postcode': value['postcode'],
        'country': value['country'],
        'sanctionsCompleted': value['sanctionsCompleted'],
        'sanctionsCompletedDate': value['sanctionsCompletedDate'] == null ? undefined : ((value['sanctionsCompletedDate']).toISOString()),
        'comment': value['comment'],
        'state': value['state'],
    };
}

